import { Box, FormControl, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialMenu from "../../components/MaterialMenu";
import { ReactComponent as SettingIcon } from "../../assets/icons/icon-feather-settings-primary.svg"
import FilterDateRangeView from "../../components/_report/cards/FilterDateRangeView";
import FilterSingleDate from "../../components/_report/cards/FilterSingleDate";
import FilterGreaterLessValue from '../../components/_report/cards/FilterGreaterLessValue';
import FilterMultipleSelectValue from '../../components/_report/cards/FilterMultipleSelectValue';
import FilterSelectValue from '../../components/_report/cards/FilterSelectValue';
import { addMeasures, getMeasureById, getMeasuresList } from '../../config/services/measures'
import { GREATER_LESS_THAN_FILTER, NUMBER_FILTER_TYPE } from '../../constants/filterType'
import { containsSpecialCharacter, generateCustomDateRange, isMobileView } from '../../utils/Reusables'
import moment from "moment";
import toast from "react-hot-toast";

const ReportGraphFilters = ({reportDetailsInfo}) => {

    const [filterMoreEl, setFilterMoreEl] = useState(null);
    const openFilterMoreMenu = Boolean(filterMoreEl);
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [measureList, setMeasureList] = useState([]);
    const [openPopupFilter, setOpenPopupFilter] = useState(false);
    const [deleteObj, setDeleteObj] = useState({});
    const [deletePopup, setDeletePopup] = useState(false);
    const [reportDetails, setReportDetails] = useState(reportDetailsInfo);

    useEffect(() => {
        console.log("kkk", reportDetails)
    }, [])

    const handleFilterMoreMenuClick = (event) => {
        if (filterMoreEl !== event.currentTarget) {
        setFilterMoreEl(event.currentTarget);
        }
    };

    const handleFilterMoreMenuClose = () => {
        setFilterMoreEl(null);
    };

    const getFilterLabel = (filterObj) => {
        let { displayName, operator } = filterObj
    
        if (GREATER_LESS_THAN_FILTER.includes(operator)) {
          return `${displayName} ${NUMBER_FILTER_TYPE[operator]}`;
        }
    
        if (displayName && displayName.length && displayName?.includes('select') || displayName?.includes('Select') || displayName?.includes('SELECT')) {
          return displayName;
        }
        else {
          return `${displayName}`;
        }
    }

    const getMeasureList = () => {
        if (reportDetails?.reportDetails?.dataSetId?._id) {
          let params = { dataSetId: reportDetails?.reportDetails?.dataSetId?._id, sortKey: 'name', sortOrder: 1 }
          getMeasuresList(params)
            .then((res) => {
              setMeasureList(res.result);
            });
        }
    }

    const handleEditReportFilter = (obj, index) => {
        if (obj) {
          if (obj?.valuesList?.length)
            obj.valuesList = obj?.valuesList?.join("\n");
    
          setRecordForEdit({ ...obj, index })
          getMeasureList()
          setOpenPopupFilter(true)
        }
    }

    const handleDeleteReportFilterPopUp = (obj) => {
        setDeleteObj({ ...obj })
        setDeletePopup(true)
    }

    const handleToggleHideReportFilter = (obj) => {
        //console.log('obj', obj)
        let index = reportDetails?.reportDetails?.reportFilters?.findIndex(filter => filter.member === obj.member && filter.operator === obj.operator && filter.filterOrder === obj.filterOrder);
    
        if (index >= 0) {
          reportDetails.reportDetails.reportFilters[index].hidden = !reportDetails.reportDetails.reportFilters[index].hidden ?? true;
          updateReportDetails({ reportDetails: reportDetails.reportDetails })
        }
    }

    const handleDateFilter = (e, obj, i, dateType) => {
        let value = e;
        let timeFlag = obj?.dateFilterProps && obj?.dateFilterProps?.dateRangeType === "dateTime" ? true:false
        
        if (moment(value).isValid()) {
          value = moment(value).format("YYYY-MM-DD HH:mm:ss")
        }
        else {
          value = ''
        }
        let newDates = [...obj.values]
        //console.log(timeFlag,obj)
        switch (dateType) {
          case 'startDate':
            newDates[0] = value
            break
          case 'endDate':
            newDates[1] =   value && !timeFlag ? moment(value).endOf('day').format('YYYY-MM-DD HH:mm:ss') : value
            break
          case 'singleDate':
            newDates[0] = value
            break
        }
        //console.log(newDates)
        if (newDates[0] && newDates[1]) {
          const startDate = new Date(newDates[0]);
          const timestamp1 = startDate.getTime();
    
          const endDate = new Date(newDates[1]);
          const timestamp2 = endDate.getTime();
    
          if (timestamp1 && timestamp2 && (timestamp1 > timestamp2)) {
            // [newDates[0], newDates[1]] = [newDates[1], newDates[0]];
            toast.error("Start date cannot be after End Date")
            return
          }
        }
    
        reportDetails.reportDetails.reportFilters[i].values = newDates;
        updateReportDetails({ reportDetails: reportDetails.reportDetails });
    }

    const handleChangeFilterFromList = (obj, index, e) => {
        // e.target.value = typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value;
    
        // reportDetails.reportDetails.reportFilters[index].values = e.target.value;
    
        updateReportDetails({ reportDetails: reportDetails.reportDetails });
    }

    const updateReportDetails = (value) => {
        setReportDetails(value)
    }

    const handleTimePeriodFilter = (value, obj, i, dateType) => {
        const { startDate, endDate } = generateCustomDateRange(value)
        let newDates = [startDate, endDate]
        reportDetails.reportDetails.reportFilters[i].values = newDates;
        reportDetails.reportDetails.reportFilters[i].dateFilterProps.selectedTimePeriod = value;
        updateReportDetails({ reportDetails: reportDetails.reportDetails });
    }
    
    

    return (
        reportDetails?.reportDetails?.reportFilters?.length
            ?   <Box className="re-report-graph-filters-list">
                    {reportDetails?.reportDetails?.reportFilters?.map((obj, i) => (
                    
                        <Box key={i} className="dashboard-filters-view-item" >
                            <Box>
                                <Grid xs={12} item display="flex" alignItems={'center'} >
                                    <Grid>
                                        <Typography className="report-form-label text-left" variant="body2" > {getFilterLabel(obj)} </Typography>
                                    </Grid>
                                    <Grid>
                                        <MaterialMenu icon={<SettingIcon />}
                                            onClose={handleFilterMoreMenuClose}
                                            options={[
                                                { label: 'Edit', func: () => handleEditReportFilter(obj, i) },
                                                { label: 'Delete', func: () => handleDeleteReportFilterPopUp(obj) },
                                                { label: obj?.hidden ? 'Unhide' : 'Hide', func: () => handleToggleHideReportFilter(obj) }
                                            ]}
                                        />
                                    </Grid>
                                </Grid>
                                {
                                obj.operator === "inDateRange" || obj.operator === "notInDateRange" ?
                                    <FilterDateRangeView obj={obj} i={i} handleDateFilter={handleDateFilter} showLabel={false} handleTimePeriodFilter={handleTimePeriodFilter} />
                                    :
                                    obj.operator === "beforeDate" || obj.operator === "afterDate" ?
                                    <FilterSingleDate obj={obj} i={i} handleDateFilter={handleDateFilter} showLabel={false} />
                                    :
                                    GREATER_LESS_THAN_FILTER.includes(obj.operator) && obj?.listType === 'inputValue' ?
                                        <FilterGreaterLessValue handleChangeFilterFromList={handleChangeFilterFromList} filterCondtion={obj} i={i}
                                            reportDetails={reportDetails}
                                            updateReportDetails={updateReportDetails} />
                                        :
                                        (obj?.listType === "dropdown" ?
                                        <FormControl variant="outlined" sx={{ width: '100%' }} size="small">
                                            <FilterSelectValue handleChangeFilterFromList={handleChangeFilterFromList} filterCondtion={obj} i={i}
                                                reportDetails={reportDetails}
                                                updateReportDetails={updateReportDetails}
                                                onLoader={false}
                                            />
                                        </FormControl>
                                        :
                                        <FormControl variant="outlined" sx={{ width: '100%' }} size="small">
                                            <FilterMultipleSelectValue 
                                                handleChangeFilterFromList={handleChangeFilterFromList} 
                                                filterCondtion={obj} i={i}
                                                reportDetails={reportDetails}
                                                updateReportDetails={updateReportDetails}
                                                onLoader={false}
                                            />
                                        </FormControl>
                                        )
                                }
                            </Box>
                        </Box>
                    ))}
                </Box>
                
            :   <></>
        
    )
}

export default ReportGraphFilters;